/*
  Northsheep — collapse the top menu to the hamburger the moment it stops
  fitting, rather than at a number someone typed in.

  WHY NOT JUST A BREAKPOINT. There is one ("Collapse menu to hamburger below"),
  and it cannot be right for every store: this theme ships to five, and the same
  five menu items are "Home & Living" in English and "Wohnen & Leben" in German.
  A width that fits one language overlaps the wordmark in another - which is
  exactly what the owner saw: the menu running straight through NORTHSHEEP®.

  So this measures the real thing. If the menu's right edge comes within a hair
  of the wordmark, or the wordmark of the icons, the header goes to hamburger
  mode. The breakpoint setting stays as a floor for anyone who wants to force it
  earlier.

  Measured with the class OFF, so the question is always "does it fit when
  shown", never "does it fit as it is now" - otherwise it would latch and never
  come back on a window being widened.

  SMALLER TYPE BEFORE THE HAMBURGER (owner, 24 Sep 2026: "in france can you
  make the header menu text a bit smaller size so that it fits on desktop?
  because now i directly see the floating hamburger in france even on
  desktop"). The French labels ("Peaux de mouton", "Bébé et enfant") want 650px
  at 20px where a 1440 screen offers 550, so France went straight to the
  hamburger. Now a menu that does not fit first steps down to 18px, then 16px
  with a narrower gap, and only collapses if even that does not fit. 16px is
  the floor: 15px in Cormorant's lowercase did not read (owner, 15 Sep 2026).
  A menu that fits keeps the owner's 20px - English, German and Dutch included.
  The logo stays centred on purpose: moved beside the menu it would sit in a
  different place in every store and at every window width.
*/
(function () {
  var GAP = 18; // px of daylight required between the menu and the wordmark
  var STEPS = [18, 16]; // px, tried in turn before the hamburger
  var STEP_GAP = '12px'; // gap between the links once a step is taken

  function pick(header) {
    return {
      menu: header.querySelector('.header__inline-menu'),
      logo: header.querySelector('.header__heading, .header__heading-link, .header__logo'),
      icons: header.querySelector('.header__icons'),
    };
  }

  // MEASURE THE ITEMS, NOT THE BOX. The menu's container is a grid cell and
  // stays exactly as wide as its column however long the menu gets; the list
  // inside is flex-wrap: nowrap and simply OVERFLOWS it. So the container's
  // right edge sat at 562 while the last item's was at 704, straight across a
  // wordmark starting at 615 - the box said there was room, and the eye could
  // see there was not. Measured on the real thing: the list wanted 666px of a
  // 524px cell.
  function clashes(el) {
    var list = el.menu.querySelector('ul') || el.menu;
    var items = el.menu.querySelectorAll('.header__menu-item');
    var last = items.length ? items[items.length - 1] : null;

    var l = el.logo.getBoundingClientRect();
    if (!l.width) return false;

    var right = last ? last.getBoundingClientRect().right
                     : el.menu.getBoundingClientRect().right;
    var clash = right + GAP > l.left;

    // Belt and braces: a list that does not fit its own cell has already
    // lost, whatever it overlaps.
    if (!clash && list.scrollWidth > list.clientWidth + 1) clash = true;

    if (!clash && el.icons) {
      var i = el.icons.getBoundingClientRect();
      clash = l.right + GAP > i.left && l.left < i.right;
    }
    return clash;
  }

  function unstep(header) {
    header.style.removeProperty('--ns-menu-fs');
    header.style.removeProperty('--ns-menu-gap');
  }

  function check() {
    document.querySelectorAll('.header').forEach(function (header) {
      var el = pick(header);
      if (!el.menu || !el.logo) return;

      header.classList.remove('ns-header--nofit');
      unstep(header);

      // Already in hamburger mode from the media query: nothing to decide.
      if (getComputedStyle(el.menu).display === 'none') return;

      if (!clashes(el)) return;

      var first = el.menu.querySelector('.header__menu-item');
      var base = first ? parseFloat(getComputedStyle(first).fontSize) : 20;
      for (var s = 0; s < STEPS.length; s++) {
        if (STEPS[s] >= base) continue;
        header.style.setProperty('--ns-menu-fs', STEPS[s] + 'px');
        header.style.setProperty('--ns-menu-gap', STEP_GAP);
        if (!clashes(el)) return;
      }

      unstep(header);
      header.classList.add('ns-header--nofit');
    });
  }

  var t;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(check, 60); // the grid convention in this theme
  }

  if (document.readyState !== 'loading') check();
  else document.addEventListener('DOMContentLoaded', check);

  // The wordmark and the menu are set in Cormorant Garamond. Until it loads,
  // the measurement is of the fallback face - a different width, and the menu
  // in the real face is the wider of the two, so an early measurement says it
  // fits when it does not. Hence three more triggers, not one:
  //   fonts.ready   the font swap itself
  //   load          images and late CSS, which can still move the row
  //   ResizeObserver  anything else at all that changes either width
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
  window.addEventListener('load', check);

  if (window.ResizeObserver) {
    var ro = new ResizeObserver(schedule);
    document.querySelectorAll('.header').forEach(function (header) {
      var el = pick(header);
      [el.menu, el.logo, el.icons, header].forEach(function (n) { if (n) ro.observe(n); });
    });
  }

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
})();
